import app from 'flarum/forum/app';
import { addMeritButtons } from './addMeritButtons';
import { addHighlightButton } from './addHighlightButton';
import { addRankBadge } from './addRankBadge';
import { addMeritProfileSection } from './addMeritProfileSection';
import MeritDashboardPage from './components/MeritDashboardPage';
import MeritUserPage from './components/MeritUserPage';

app.initializers.add('predictiontalk-merit-system-forum', () => {
    app.routes['merit'] = { path: '/merit', component: MeritDashboardPage };
    app.routes['user.merit'] = { path: '/u/:username/merit', component: MeritUserPage };

    addMeritButtons();
    addHighlightButton();
    addRankBadge();
    addMeritProfileSection();
});
